import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-x2 sm:mb-x3" }

import { ProductSpecificationTileModel } from '@/types/B2BcontentServerContract';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { Tabs, TabContent } from '@/shared/navigation/tabs';
import ProductSpecificationsDetails from '@/shared/product/details/ui/product-specifications/ProductSpecificationsDetails.vue';
import ProductCoverDetails from '@/shared/product/details/ui/product-specifications/ProductCoverDetails.vue';
import ProductTransparencyDetails from '@/shared/product/details/ui/product-specifications/ProductTransparencyDetails.vue';
import useProductSpecificationsData from '@/shared/product/details/ui/product-specifications/useProductSpecificationsData';
import { computed } from 'vue';
import useProductSpecificationsTile
    from '@/shared/product/details/ui/product-specifications/useProductSpecificationsTile';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSpecificationsTabs',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as {
    content: ProductSpecificationTileModel;
}



const { specifications, coverMaterial, climateEmissionsCollection, productId } = useProductSpecificationsData();
const { selectedTabIndex, setSelectedTabIndex, setTransparencyReadMoreLinks } = useProductSpecificationsTile();

setTransparencyReadMoreLinks(props.content);

const labels = useBlockLabels();
const tabTitles = computed(() => {
    const tabs: string[] = [];
    if (specifications.value) {
        tabs.push(labels.specificationTitle ?? 'specificationTitle');
    }
    if (coverMaterial.value) {
        tabs.push(labels.coverTitle ?? 'coverTitle');
    }
    if (specifications.value?.certificates || climateEmissionsCollection.value) {
        tabs.push(labels.transparencyTitle ?? 'transparencyTitle');
    }
    return tabs;
});

const defaultTabIndex = computed(() => {
    const tabsCount = tabTitles.value.length;
    return selectedTabIndex.value < tabsCount ? selectedTabIndex.value : 0;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(labels).title), 1),
    (_openBlock(), _createBlock(_unref(Tabs), {
      key: _unref(productId),
      "tab-titles": _unref(tabTitles),
      "default-index": _unref(defaultTabIndex),
      onClick: _unref(setSelectedTabIndex)
    }, {
      default: _withCtx(() => [
        (_unref(specifications))
          ? (_openBlock(), _createBlock(_unref(TabContent), { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(ProductSpecificationsDetails)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(coverMaterial))
          ? (_openBlock(), _createBlock(_unref(TabContent), { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(ProductCoverDetails)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_unref(TabContent), null, {
          default: _withCtx(() => [
            _createVNode(ProductTransparencyDetails)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["tab-titles", "default-index", "onClick"]))
  ], 64))
}
}

})